import type { FormSubmissionParams } from '../entities';

export const createFormDataFromSubmissionParams = (
  params: FormSubmissionParams,
  attachments: Array<File> = [],
): FormData => {
  const formData = new FormData();

  Object.entries({
    formId: params.formId.toString(),
    subject: params.subject,
    requesterName: params.requesterName,
    requesterEmail: params.requesterEmail,
    description: params.description,
    termsAccepted: String(params.termsAccepted),
  }).forEach(([key, value]) => {
    formData.append(key, value);
  });

  attachments.forEach((file) => {
    formData.append('attachments', file);
  });

  return formData;
};
